module.exports = __webpack_public_path__ + "static/media/note.3f8e3551.svg";